var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 13V8H1a1 1 0 01-1-1 1 1 0 011-1h5V1a1 1 0 011-1 1 1 0 011 1v5h5a1 1 0 011 1 1 1 0 01-1 1H8v5a1 1 0 01-1 1 1 1 0 01-1-1z"
  })));
}
export default SvgPlusIcon;